import { environmentHttpClient } from "client/Api/httpClient";

export enum UserProvisioningKind {
	None = 0,
	AdSync = 1,
	Scim = 2
}

export enum ManageAdminRoleLocation {
	AzureAD = 0,
	Workspace = 1
}

export type UserProvisioningSettingsViewModel = {
	model: UserProvisioningSettingsModel;
	shouldSpecifyComputerName: boolean;
	isScimProvisioningAvailable: boolean;
	isAdSyncAvailable: boolean;
	computerName: string;
};

export type NoneUserProvisioningSettingsModel = {
	kind: UserProvisioningKind.None;
};

export type AdSyncUserProvisioningSettingsModel = {
	kind: UserProvisioningKind.AdSync;
	isEnabled: boolean;
	hasAuthenticationToken: boolean;
	manageAdminRoleLocation: ManageAdminRoleLocation;
	canManageUserActiveStatusInWorkspace: boolean;
};

export type ScimUserProvisioningSettingsModel = {
	kind: UserProvisioningKind.Scim;
	isEnabled: boolean;
	shouldActivateUserByDefault: boolean;
	hasAuthenticationToken: boolean;
};

export type UserProvisioningSettingsModel =
	| NoneUserProvisioningSettingsModel
	| AdSyncUserProvisioningSettingsModel
	| ScimUserProvisioningSettingsModel;

export type UserProvisioningSettingsSaveModel = {
	kind: UserProvisioningKind;
	adSync?: AdSyncUserProvisioningSettingsSaveModel;
	scim?: ScimUserProvisioningSettingsSaveModel;
	computerName: string;
};

export type AdSyncUserProvisioningSettingsSaveModel = {
	isEnabled: boolean;
	manageAdminRoleLocation: ManageAdminRoleLocation;
	canManageUserActiveStatusInWorkspace: boolean;
};

export type ScimUserProvisioningSettingsSaveModel = {
	isEnabled: boolean;
	shouldActivateUserByDefault: boolean;
};

export type UserProvisioningSettingsRegenerateTokenModel = {
	kind: UserProvisioningKind;
};

export type UserProvisioningSettingsNewTokenResultModel = {
	newlyGeneratedAuthenticationToken: OptionalModel<string>;
};

export async function get(
	signal?: AbortSignal
): Promise<UserProvisioningSettingsViewModel> {
	return await environmentHttpClient.get<UserProvisioningSettingsViewModel>(
		"UiApi/UserProvisioningSettings",
		undefined,
		{ signal }
	);
}

export async function save(
	model: UserProvisioningSettingsSaveModel,
	signal?: AbortSignal
): Promise<UserProvisioningSettingsNewTokenResultModel> {
	return await environmentHttpClient.put<UserProvisioningSettingsNewTokenResultModel>(
		"UiApi/UserProvisioningSettings",
		model,
		{ signal }
	);
}

export async function regenerate(
	model: UserProvisioningSettingsRegenerateTokenModel,
	signal?: AbortSignal
): Promise<UserProvisioningSettingsNewTokenResultModel> {
	return await environmentHttpClient.post<UserProvisioningSettingsNewTokenResultModel>(
		"UiApi/UserProvisioningSettings/Regenerate",
		model,
		{ signal }
	);
}